module.exports = __webpack_public_path__ + "img/bory1_small.f81e08f8.png";